import React, { useState } from "react";
import { Button, Grid } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";

import usePatientModal from "components/pages/transmissions/modal/patient/usePatientModal";
import PatientTransmissionInfo from "components/pages/transmissions/modal/patient/tabs/generalInformation/transmission/PatientTransmissionInfo";

import { updateNextBillingDateChangedStatus } from "app/store/transmission/slice/transmissionSlice";

import { showErrorToast } from "utils/toast";
import { getFormattedDate, isValidDateFormat } from "utils/date";

import { RPM_DEVICE_MANUFACTURER } from "static/constants";
import { DATE_FORMAT } from "static/date";

const TransmissionForm = () => {
  const { profile } = useSelector((state) => state.transmission);
  const { handleTransmission, handleCancel } = usePatientModal();
  const [isEditMode, setIsEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const handleSave = async (values) => {
    try {
      setIsLoading(true);
      const response = await handleTransmission(values);
      if (!response?.error) {
        setIsEditMode(false);
        dispatch(updateNextBillingDateChangedStatus(false));
      }
    } catch (error) {
      showErrorToast(error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const checkSubmitAllowed = () => {
    let { nextSendDays, next_send, next_bill_date, manufacturer } = profile;
    next_send = getFormattedDate(next_send, DATE_FORMAT.DEFAULT);
    next_bill_date = getFormattedDate(next_bill_date, DATE_FORMAT.DEFAULT);

    // check if nextSendDate is of valid format
    const isNextSendDateValid =
      next_send && isValidDateFormat(next_send, "MM/DD/YYYY");

    // check if nextSendDays exists and is greater than 0 and less than 366
    const isNextSendDaysValid =
      nextSendDays && nextSendDays > 0 && nextSendDays < 366;

    // check if nextBillingDate is of valid format only if it exists
    let isNextBillingDateValid = true;
    if (next_bill_date) {
      isNextBillingDateValid = isValidDateFormat(next_bill_date, "MM/DD/YYYY");
    }

    const { bpCuff, holterMonitor, scale } = RPM_DEVICE_MANUFACTURER;
    const isRpmPatient =
      manufacturer === bpCuff ||
      manufacturer === holterMonitor ||
      manufacturer === scale ||
      manufacturer === "";

    /**
     * if any of the above conditions are false, disallow submit
     * ignore the validations for RPM patients
     */
    const isInvalid = !isRpmPatient
      ? !isNextSendDateValid || !isNextSendDaysValid || !isNextBillingDateValid
      : false;

    return isInvalid;
  };

  return (
    <>
      <Grid container className="patient-modal__aside-container mb-3">
        <Grid item container>
          <Grid item xs={11} style={{ textAlign: "left" }}>
            <div className="patient-form__info--header">Transmission</div>
          </Grid>
          {!isEditMode && (
            <Grid item xs={1} style={{ textAlign: "right" }}>
              <Button
                variant="text"
                color="secondary"
                className="profile-edit-button"
                onClick={() => setIsEditMode(true)}
              >
                <EditIcon
                  className="patient-edit-icon billing-cycle-edit-icon"
                  data-action="edit-transmission-information-icon"
                />
                Edit
              </Button>
            </Grid>
          )}
        </Grid>

        <PatientTransmissionInfo
          style={{ marginTop: "16px" }}
          isEditMode={isEditMode}
          isLoading={isLoading}
          handleCancel={handleCancel}
          handleSubmit={handleSave}
          setIsEditMode={setIsEditMode}
          disabled={checkSubmitAllowed()}
        />
      </Grid>
    </>
  );
};

export default TransmissionForm;
